import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { BreadCrumbs } from '../../Layout/Header/BreadCrumbs';

import { AddRecord } from '@components/ActionButtons';
import { BoxBodyContainer, BoxHeaderTitle } from '@components/Box';
import { BreadcrumbsContainer } from '@components/BreadcrumbsContainer';
import { GridHeaderMenuTitle } from '@components/HeaderTitle';
import { routes } from '@config/routes';

export const RecurringInvoice = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const baseBreadCrumbs = [{ link: 'Revenue and Collections', to: '' }];

  const isOnHomePage = location.pathname === routes.RNC_RECURRING_INVOICES;

  const breadCrumbLinks = isOnHomePage
    ? baseBreadCrumbs
    : [
        ...baseBreadCrumbs,
        { link: 'Recurring Invoice', to: routes.RNC_RECURRING_INVOICES },
      ];

  return (
    <>
      <div className="p-4 space-y-4">
        <BreadcrumbsContainer>
          <div className="text-sm font-semibold text-gray-500">
            Revenue and Collections
          </div>
          <div>
            <BreadCrumbs links={breadCrumbLinks} />
          </div>
        </BreadcrumbsContainer>

        <div>
          <div className="flex justify-between items-center space-x-5">
            <BoxHeaderTitle>
              <GridHeaderMenuTitle>
                <div className="lg:text-2xl md:text-xl text-md lg:font-black md:font-black font-bold">
                  Recurring Invoice
                </div>
              </GridHeaderMenuTitle>
            </BoxHeaderTitle>

            <div className="">
              {isOnHomePage && (
                <div className="flex flex-row space-x-1">
                  <AddRecord
                    label="Create Recurring Invoice"
                    onClick={() => {
                      navigate(`${routes.RNC_RECURRING_INVOICES}/create`);
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="p-4 bg-white rounded-b-xl rounded-tr-xl">
            <BoxBodyContainer>
              <Outlet />
            </BoxBodyContainer>
          </div>
        </div>
      </div>
    </>
  );
};
